import { useEffect, useRef, useState } from 'react'
import { useLangContext } from 'contexts/LangContext'
import './LanguageSelect.css'

export const LanguageSelect = () => {
  const { selectedLanguage, changeSelectedLanguage } = useLangContext()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  const options = [
    { value: 'ptbr', label: 'PT' },
    { value: 'en', label: 'EN' },
    { value: 'es', label: 'ES' },
  ]

  const handleLanguageChange = (value) => {
    changeSelectedLanguage(value)
    localStorage.setItem('app_language', value)
    setOpen(false)
  }

  const initAppLanguage = () => {
    const savedLanguage = localStorage.getItem('app_language')
    if (savedLanguage && savedLanguage !== selectedLanguage) {
      changeSelectedLanguage(savedLanguage)
    }
  }

  // fechar ao clicar fora
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [])

  useEffect(() => {
    initAppLanguage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const selectedLabel = options.find((o) => o.value === selectedLanguage)?.label

  return (
    <div className="lang-select" ref={ref}>
      <div className="lang-select__trigger" onClick={() => setOpen(!open)}>
        <span>{selectedLabel}</span>

        <span className={`lang-select__arrow ${open ? 'open' : ''}`} />
      </div>

      {open && (
        <div className="lang-select__dropdown">
          {options.map((opt) => (
            <div
              key={opt.value}
              className={`lang-select__option ${
                opt.value === selectedLanguage ? 'lang-select__option--active' : ''
              }`}
              onClick={() => handleLanguageChange(opt.value)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
